import React from "react";
import "./App.css";
import { HashRouter as Router, Switch, Route } from "react-router-dom";

import "./assets/fonts/MontserratAlternates-Black.ttf";
import "./assets/styles/style.css";

import Index from "./Components/Index/Index";
import Contact from "./Components/Contact/Contact";
import Navbar from "./Layout/Navbar";
import Works from "./Components/Works/Works";
import Skills from "./Components/Skills/Skills";

const App = () => {
  return (
    <div>
      <Router>
        <Navbar />
        <Switch>
          <Route path="/contact" component={Contact} exact />
          <Route path="/works" component={Works} exact />
          <Route path="/skills" component={Skills} exact />
          <Route path="/" component={Index} exact />
        </Switch>
      </Router>
    </div>
  );
};

export default App;
